export default "__VITE_ASSET__DtEcUHtI__"